<div>
  <div class="item__product border-radius">
    @if (image$ | async; as image) {
      <video
        controls
        [src]="image.thumbnail.url"
        [width]="image.thumbnail.width"
        [height]="image.thumbnail.height"
      ></video>
    }
  </div>
</div>
